import React from "react";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { NotificationManager } from "react-notifications";
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@mui/material/Button";
import OrganizationConfig from "../../apis/globalConfiguration/organizationConfig";
import OrganizationConfigEdit from "../../apis/globalConfiguration/organizationConfigEdit";
import OrganizationConfigDelete from "../../apis/globalConfiguration/organizationConfigDelete";
import "./TestTakingStyle.css";
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from "../../components/DataTable/DataTable";

const styleSx = {
  table: {
    minWidth: 650,
  },
  bodyForSupport: {
    padding: "0px 30px!important",
  },
  buttonForSupport: {
    justifyContent: "flex-end !important",
    padding: "25px 30px 30px!important",
  },
  deleteButtonForSupport: {
    justifyContent: "flex-end !important",
    padding: "25px 30px 30px!important",
    textAlign: "center"
  },
  title: {
    padding: "16px 30px!important",
  },
  label: {
    display: "inline-block",
    fontSize: "17px",
    color: "#04093F",
    fontFamily: "Segoe-Regular",
    fontStyle: "normal",
    marginBottom: "10px !important"
  },
  bodyForShare: {
    padding: "0px 30px!important",
  },
};



const TestTakingInterval = ({ data, org, userType,isDataLoaded }) => {
  // "org" is the API data for getting all R.O
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [dataForEdit, setDataForEdit] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedDays, setSelectedDays] = useState(null);
  const [isDataUpdated, setIsDataUpdated] = useState(true);
  const [result, setResult] = useState([]);
  const [atvBtn, setAtvBtn] = useState(false);

  const closeModal = () => {
    if (openEditModal) {
      setOpenEditModal(false);
    } else {
      setOpenAddModal(false);
    }
    setSelectedOrg(null);
    setSelectedDays(null);
    setDataForEdit(null);
    setDeleteData(null);
  };
  const openModal = (list) => {
    setOpenEditModal(true);
    // data for edit modal
    setDataForEdit(list);
    setSelectedOrg(list.recruitmentpartner);
    setSelectedDays(list.valuInDays);
    setDeleteData(list);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
  }

  const openDeleteModal = (list) => {
    setDeleteModal(true);
  }

  const openAddForm = () => {
    setOpenAddModal(true);
  };

  const addHandler = async () => {
    setAtvBtn(true);
    if (selectedOrg === null || selectedDays === null) {
      setAtvBtn(false);
      NotificationManager.error("Please fill in all the fields", "Error", 10000);
      return;
    }
    else if (selectedDays <= 0) {
      setAtvBtn(false);
      NotificationManager.error("Please enter a valid number of days", "Error", 10000);
      return;
    } else {
      const payload = {
        code: "TestReminderInterval",
        name: "Test Reminder Interval",
        value: (selectedDays * 24 * 60).toString(), // in minutes
        organizationId: selectedOrg?.id,
        createdBy: userType?.id,
        updatedBy: userType?.id,
      };

      try {
        const resp = await OrganizationConfig(payload);
        if (resp.data.message === "This organization already exist in our system") {
          setAtvBtn(false);
          NotificationManager.error("This organization is already existed in our system", "Error", 10000);
        }
        else {
          NotificationManager.success("Data added successfully", "Success", 10000);
          closeModal();
          setAtvBtn(false);
          setIsDataUpdated(true);
        }
      } catch (err) {
        console.log("Error", err);
        setAtvBtn(false);
        return;
      }
    }
  };

  const updateHandler = async () => {
    setAtvBtn(true);
    if (selectedOrg === null || selectedDays === null) {
      setAtvBtn(false);
      NotificationManager.error("Please fill in all the fields", "Error", 10000);
      return;
    }
    else if (selectedDays <= 0) {
      setAtvBtn(false);
      NotificationManager.error("Please enter a valid number of days", "Error", 10000);
      return;
    } else {
      const payload = {
        code: "TestReminderInterval",
        name: "Test Reminder Interval",
        value: (selectedDays * 24 * 60).toString(), // in minutes
        organizationId: selectedOrg?.id,
        createdBy: userType?.id,
        updatedBy: userType?.id,
      };

      try {
        await OrganizationConfigEdit(payload, dataForEdit?.id);
        NotificationManager.success("Data updated successfully", "Success", 10000);
        setAtvBtn(false);
        closeModal();
        setIsDataUpdated(true);
      } catch (err) {
        console.log("Error", err);
        setAtvBtn(false);
        return;
      }
    }
  };

  const deleteHandler = async () => {
    if (deleteData?.id) {
      try {
        await OrganizationConfigDelete(deleteData?.id);
        NotificationManager.success("Data is deleted successfully", "Success", 10000);
        setIsDataUpdated(true);
        setDeleteModal(false);
        setDeleteData("");
        closeModal();
      }
      catch (err) {
        console.log("Error", err);
      }
    }
  }

  const orgChange = async (event, value) => {
    setSelectedOrg(value);
  };

  const changeDays = async (e) => {
    setSelectedDays(e.target.value);
  };

  const getAllDataOfOrg = async () => {

    try {
      const resp = await OrganizationConfig();
      resp?.data?.data.map(
        (item, i) => (item.valuInDays = parseInt(item.value) / 24 / 60)
      );

      setResult(resp?.data?.data || []);
      return;
    } catch (err) {
      console.log("Error", err);
      return err;
    }

  };

  useEffect(() => {

    if (isDataUpdated) {
      getAllDataOfOrg();

      setIsDataUpdated(false);
    }

  }, [isDataUpdated]);

  let columns = [
    {
      accessorKey: "recruitmentpartner.name",
      header: "Recruitment Organization",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "valuInDays",
      header: "Days",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <>
          <button
            className='editBtn_manageSpoc'
            onClick={() => openModal(row.original)}
          >
            Edit
          </button>
        </>
      ),
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
    },
  ]

  return (
    <>
      <h3 className="fs-semi-bold fs-30 f-color">Test Interval</h3>
      {/*KENDO GRID */}
      <div className="addIntervalButton">
        <Button
          variant="contained"
          color="primary"
          onClick={() => openAddForm()}
        >
          Add New Test Reminder
        </Button>
      </div>

      <DataTable
        data={result}
        columns={columns}
        isLoading={!isDataLoaded}
      />

      {/* Edit Modal */}
      <Dialog
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="admindailog_title_modal_global_config"
        >
          Edit Test Reminder
        </DialogTitle>

        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="select customized-select">
            <div>
              <label sx={styleSx.label} htmlFor="country">
                Recruitment Organization*
              </label>
              <Autocomplete
                id="combo-box-demo"
                className="mt_11"
                options={org.filter((item) => item.isActive === true)}
                autoHighlight
                disabled
                value={selectedOrg}
                getOptionLabel={(option) => option?.name || ""}
                getOptionSelected={(option, value) =>
                  value ? option.id === value.id : true
                }
                onChange={orgChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    required
                    placeholder="Select Recruitment Organization"
                  />
                )}
              />
            </div>
            <div className="mt_15">
              <label className="field_name" htmlFor="country">
                Days*
              </label>
              <input
                type="number"
                className="text_box_cleartalent custom-text-width-demo-email configaration_input mt_8"
                defaultValue={selectedDays || ""}
                min="0"
                onChange={(e) => changeDays(e)}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport}>
          <button
            type="button"
            className="btn-big btn-skill cp"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-big btn-skill cp"
            onClick={openDeleteModal}
          >
            Delete
          </button>
          <button variant="outlined" className="btn5 btn_primary cp" disabled={atvBtn} onClick={updateHandler}>
            <div className="btn_loader">
              Submit
              &nbsp;
              {atvBtn &&
                <div >
                  <CircularProgress size={15} />
                </div>
              }
            </div>
          </button>
        </DialogActions>
      </Dialog>

      {/* Add modal */}
      <Dialog
        open={openAddModal}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="admindailog_title_modal_global_config"
        >
          Add New Test Reminder
        </DialogTitle>

        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="select customized-select">
            <div>
              <label sx={styleSx.label} htmlFor="country">
                Recruitment Organization*
              </label>
              <Autocomplete
                id="combo-box-demo"
                className="mt_11"
                options={org.filter((item) => item.isActive === true)}
                autoHighlight
                value={selectedOrg || null}
                getOptionLabel={(option) => option?.name || ""}
                getOptionSelected={(option, value) =>
                  value ? option.id === value.id : true
                }
                onChange={orgChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    required
                    placeholder="Select Recruitment Organization"
                  />
                )}
              />
            </div>
            <div className="mt_15">
              <label className="field_name" htmlFor="country">
                Days*
              </label>
              <input
                type="number"
                className="text_box_cleartalent custom-text-width-demo-email configaration_input mt_8"
                value={selectedDays || ""}
                min="0"
                onChange={(e) => changeDays(e)}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport}>
          <button
            type="button"
            className="btn5 btn-skill cp"
            onClick={closeModal}
          >
            Cancel
          </button>

          <button variant="outlined" className="btn5 btn_primary cp" disabled={atvBtn} onClick={addHandler}>
            <div className="btn_loader">
              Submit
              &nbsp;
              {atvBtn &&
                <div >
                  <CircularProgress size={15} />
                </div>
              }
            </div>
          </button>
        </DialogActions>
      </Dialog>

      {/* Delete modal */}
      <Dialog
        open={deleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="responsive_title"
        >
          Delete Test Reminder
        </DialogTitle>
        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="fs-semi-bold f-color fs-18">
            Do you want to delete the test reminder for {deleteData?.recruitmentpartner?.name} ?
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.deleteButtonForSupport}>
          <button
            type="button"
            className="btn-big btn-skill cp"
            onClick={closeDeleteModal}
          >
            No
          </button>
          <button
            type="button"
            className="btn-big btn_primary cp"
            onClick={deleteHandler}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TestTakingInterval;
